import { render, staticRenderFns } from "./withSidebar.vue?vue&type=template&id=298f3689&"
import script from "./withSidebar.vue?vue&type=script&lang=js&"
export * from "./withSidebar.vue?vue&type=script&lang=js&"
import style0 from "./withSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports